// src/pages/NotFound/NotFoundPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.scss';

const NotFoundPage = () => {
  return (
    <div className={styles.container}>
      <p>Страница не найдена</p>
      <h1>404</h1>
      <Link to="/vacancies">На главную</Link>
    </div>
  );
};

export default NotFoundPage;
